import katex from "katex"

// Renderiza texto que pode conter LaTeX delimitado por $...$ (inline) ou $$...$$ (bloco).
// Texto fora dos cifrões é escapado; quebras de linha são preservadas via `whitespace-pre-line`
// na tag pai. "R$" (moeda) é protegido para não ser interpretado como abertura de fórmula.

const SENTINEL = String.fromCharCode(1) // marca temporária no lugar do "$" de "R$"
const SENTINEL_RE = new RegExp(SENTINEL, "g")

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(SENTINEL_RE, () => "$") // restaura o "$" da moeda
}

function renderMath(tex: string, display: boolean): string {
  try {
    return katex.renderToString(tex.replace(SENTINEL_RE, () => "$"), {
      throwOnError: false,
      displayMode: display,
    })
  } catch {
    const d = display ? "$$" : "$"
    return escapeHtml(d + tex + d)
  }
}

// $$...$$ (bloco) ou $...$ (inline). Inline não cruza quebra de linha nem outro "$".
const SEG = /\$\$([\s\S]+?)\$\$|\$([^$\n]+?)\$/g

// Escapa texto e renderiza LaTeX ($...$). Exportado para reuso pelo RichContent,
// que aplica isto por nó de texto dentro do HTML do enunciado.
export function toHtml(raw: string): string {
  const text = raw.replace(/R\$/g, "R" + SENTINEL) // protege moeda
  let html = ""
  let last = 0
  let m: RegExpExecArray | null
  SEG.lastIndex = 0
  while ((m = SEG.exec(text)) !== null) {
    html += escapeHtml(text.slice(last, m.index))
    const display = m[1] !== undefined
    html += renderMath(display ? m[1] : m[2], display)
    last = m.index + m[0].length
  }
  html += escapeHtml(text.slice(last))
  return html
}

interface MathTextProps {
  text: string
  className?: string
}

export default function MathText({ text, className }: MathTextProps) {
  return <span className={className} dangerouslySetInnerHTML={{ __html: toHtml(text || "") }} />
}
